module.exports = __webpack_public_path__ + "media/35.0009edee.mp3";